module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_12_m2.b1727d346c8090508ab48046667bed30.png";